import React from "react";
import { Language } from "@mui/icons-material";
import { useLocale } from "@/middleware";
import { Link, useLocation } from "react-router-dom";
import { routes } from "@/consts";
import { LANG } from "@/types";

interface LanguageSelectorProps {
  show?: boolean;
}
const LanguageSelector: React.FC<LanguageSelectorProps> = ({ show = true }) => {
  const { locale } = useLocale();

  const location = useLocation();
  const getNextLocale = () => {
    return locale === LANG.EN ? LANG.AR : LANG.EN;
  };
  // Handle language change
  const handleLanguageSwap = () => {
    const pathName = location.pathname;
    if (!pathName) return routes.home;
    const segments = pathName.split("/");
    segments[1] = getNextLocale();
    return segments.join("/");
  };
  return (
    <Link
      to={handleLanguageSwap()}
      className="hover:text-purple-700 flex items-center gap-1"
    >
      <Language />

      {show && (locale == LANG.AR ? "ع" : `${locale}`)}
    </Link>
  );
};

export default LanguageSelector;
